import { request } from "../axios/request";

export const getUserGroupsService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/user-groups", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const saveUserGroupService = (data, id = 0) => {
  if (id > 0) {
    return async (dispatch, getState) => {
      return dispatch(
        request("/user-groups/" + id, getState(), {
          method: "PUT",
          data,
        })
      );
    };
  }
  return async (dispatch, getState) => {
    return dispatch(
      request("/user-groups", getState(), {
        method: "POST",
        data,
      })
    );
  };
};

export const deleteUserGroupService = (id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/user-groups/" + id, getState(), {
        method: "DELETE",
      })
    );
  };
};
